import React from "react";
import MainPageDialog from "../../components/mainPageDialog";

function ShowMessageDialogue({ message, setMessage }) {
  const footerList = [
    {
      title: "Close",
      type: "cancel",
      action: () => {
        setMessage({
          type: "",
          message: "",
        });
      },
    },
  ];
  return (
    <div>
      <MainPageDialog
        title={message?.type === "text" ? "Text Message" : "Email"}
        modalSize="md"
        maxHeight={true}
        footerList={footerList}
        onCancelHandler={() =>
          setMessage({
            type: "",
            message: "",
          })
        }
      >
        <div className="px-3 py-5  text-left text-sm text-gray-900">
          {message?.type === "email" && <strong>Phone Outage Message</strong>}
          <p>{message?.message}</p>
        </div>
      </MainPageDialog>
    </div>
  );
}

export default ShowMessageDialogue;
